import { Component, computed, input } from '@angular/core';
import { InnogyComponentRendering } from '@core/jss-models';
import { TextField, type RichTextField } from '@core/jss-proxy';
import { getField } from '@core/jss-utils';
import {
  computedContentSectionId,
  computedContentSectionTheme,
  ContentSectionComponent,
} from '@core/content-section';
import { GenericProductsSectionComponent } from '@content/ui/generic-products';

@Component({
  selector: 'wl-generic-products-container',
  templateUrl: './generic-products-container.component.html',
  standalone: true,
  imports: [ContentSectionComponent, GenericProductsSectionComponent],
})
export class GenericProductsContainerComponent {
  readonly rendering = input.required<InnogyComponentRendering>();
  readonly id = computedContentSectionId(this.rendering);
  readonly theme = computedContentSectionTheme(this.rendering);

  readonly fields = computed(() => this.rendering().fields);
  readonly title = computed(() => getField<TextField>(this.fields(), 'title'));
  readonly content = computed(() =>
    getField<RichTextField>(this.fields(), 'content')
  );
}
